import React from 'react';
import {Th, Thead, Tr} from "@chakra-ui/react";
import SmartIcon from "../SmartIcon.tsx";
import {MdFileDownloadOff} from "react-icons/md";
import {useProjectsStore} from "../../store/useProjectsStore.ts";

interface ITableHeader {
  label: string;
  width: string;
  align: string;
}

const TABLE_HEADERS: ITableHeader[] = [
  {label: "File", width: "350px", align: "left"},
  {label: "Language", width: "auto", align: "center"},
  {label: "Status", width: "auto", align: "center"},
  {label: "Workflow", width: "auto", align: "center"},
  {label: "Created By", width: "auto", align: "center"},
  {label: "", width: "auto", align: "center"},
]

const MainPageTableHeader: React.FC = () => {
  const {filterProjectByDownloadFlag} = useProjectsStore()
  return (
    <Thead
      className="dark:bg-n-500"
      position="sticky"
      top="0"
      zIndex="1"
    >
      <Tr>
        {TABLE_HEADERS.map(({label, width, align}: ITableHeader) => (
          <Th
            key={label}
            className="text-black dark:text-white overflow-x-auto"
            textAlign={align as "left" | "center" | "right"}
            h="50px"
            w={width || "auto"}
            maxW={width || "auto"}
            whiteSpace="normal"
          >
            {
              label === "Workflow"  ? (
                  <div className="flex items-center justify-center gap-2">
                    <span>{label}</span>
                    <div
                      className="cursor-pointer"
                      onClick={filterProjectByDownloadFlag}
                    >
                      <SmartIcon name={MdFileDownloadOff} className="w-4 h-4 fill-n-400 hover:fill-n-300"/>
                    </div>
                  </div>
                )
                : label
            }
          </Th>
        ))}
      </Tr>
    </Thead>
  )
};

export default MainPageTableHeader;
